<template>
	<div v-if="!isLoading" class="catalog-card" @click="handleClickProduct(slug)">
		<img :src="productImageUrl" alt="private-product-image" class="private-product-image" />

		<div class="catalog-body">
			<div class="catalog-info">
				<div class="catalog-product-name">
					{{ productName }}
				</div>

				<badges
					:is-lp-enabled="checkProductBadge(product, 'landing_page')"
					:is-marketing-kit-enabled="checkProductBadge(product, 'marketing_kit')"
				></badges>

				<span class="catalog-product-price">{{ formatMoney(price, 'IDR', false) }}</span>

				<div class="catalog-product-discount">
					<span class="product-discount-price">
						{{ formatMoney(slashPrice, 'IDR', false) }}
					</span>
					<discount-tag v-if="wholesale.length > 0" :discount="discount" />
				</div>

				<div class="catalog-product-additional-info">
					<div class="product-location">
						<i class="bi-geo-alt-fill"></i>
						<span class="label-text">{{ cityOrigin }}</span>
					</div>

					<span>
						Stock:
						<span :class="{ 'stock-red': isStockRed }">{{ stockView }}</span>
					</span>
				</div>
			</div>

			<button class="btn-outline o-sm outline-primary w-100 btn-sell-now">
				<span>Beli Sekarang</span>
			</button>
		</div>
	</div>
	<div v-else class="catalog-card-skeleton skeleton"></div>
</template>

<script>
import Badges from '@/components/products/Badges.vue';
import DiscountTag from '@/components/private-orders/homepage/DiscountTag.vue';
import { formatMoney, getProductBadges } from '@/lib/helper';

export default {
	components: {
		Badges,
		DiscountTag,
	},
	props: {
		productImageUrl: {
			type: String,
			default: '',
		},
		productName: {
			type: String,
			default: '',
		},
		slashPrice: {
			type: Number,
			default: 0,
		},
		cityOrigin: {
			type: String,
			default: '',
		},
		stock: {
			type: Number,
			default: 0,
		},
		wholesale: {
			type: Array,
			default: () => [],
		},
		product: {
			type: Object,
			default: () => ({}),
		},
		slug: {
			type: String,
			default: '',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		discount() {
			// eslint-disable-next-line arrow-parens
			const discountArr = this.wholesale.map((item) => parseFloat(item.discount));
			const maxDiscount = Math.max(...discountArr);
			return Math.ceil(maxDiscount).toString();
		},
		price() {
			// eslint-disable-next-line arrow-parens
			const wholesalePrices = this.wholesale.map((item) => item.price);
			return Math.min(...wholesalePrices);
		},
		stockView() {
			if (this.stock < 100) {
				return '< 100';
			}
			return this.stock;
		},
		isStockRed() {
			return this.stock < 100;
		},
	},
	methods: {
		formatMoney,
		checkProductBadge(product, key = 'cod') {
			const badges = getProductBadges(product);
			return badges[key] ?? false;
		},
		handleClickProduct(slug) {
			const encodedProductId = btoa(this.product._id);
			this.$router.push({
				name: 'wholesale-order-detail',
				params: { slug: `${slug}-${encodedProductId}` },
			});
		},
	},
};
</script>

<style scoped lang="scss">
.catalog-card {
	width: 100%;
	min-height: 475px;
	height: 475px;
	max-height: 475px;
	background-color: #ffffff;
	border-radius: 16px;
	display: flex;
	flex-direction: column;
	box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
	cursor: pointer;
}

.catalog-card-skeleton {
	width: 100%;
	min-height: 475px;
	height: 475px;
	max-height: 475px;
	border-radius: 16px;

	&.skeleton {
		margin-bottom: 0;
	}
}

img.private-product-image {
	width: 100%;
	height: 230px;
	min-height: 230px;
	margin: 0;
	border-radius: 0;
	object-fit: contain;
	border-radius: 16px 16px 0 0;
}

.catalog-body {
	width: 100%;
	height: 100%;
	background-color: #ffffff;
	border-radius: 0 0 16px 16px;
	padding: 12px 16px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.catalog-info {
	width: 100%;
	display: flex;
	flex-direction: column;
}

.catalog-product-name {
	color: #2b2f39;
	margin-bottom: 4px;
	font-weight: 600;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	max-height: 40px;
	line-height: 20px;
	height: 40px;
}

span.catalog-product-price {
	color: #ff9f1a;
	font-size: 18px;
	font-weight: 700;
}

.catalog-product-discount {
	display: flex;
	gap: 4px;
	align-items: center;
	margin-top: 4px;

	& > span.product-discount-price {
		text-decoration: line-through;
		font-size: 14px;
	}
}

.catalog-product-additional-info {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 14px;
	margin-top: 6px;
}

.product-location {
	display: flex;
	gap: 4px;
	align-items: center;
}

span.stock-red {
	color: #f04438;
}
</style>
